import { Typography } from '@mui/material';

const Dashboard = () => <Typography variant="h5">Welcome!</Typography>;

export default Dashboard;
